import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { formatDateWithTimestamp } from '../utils/date';

const initialState = {
  healthTimestamp: '',
  info: {
    appVersion: '',
    startup: '',
    serverStatus: '',
  },
  services: {},
  health: {
    db: {
      name: '',
      status: '',
    },
    diskSpace: {
      total: '',
      free: '',
    },
  },
  auditLoginEvents: [],
  httpTraces: [],
  loading: false,
  error: undefined,
};

const adminPanelSlice = createSlice({
  name: 'adminPanel',
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    actionError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    reset: () => initialState,
    setInfoData(state, action) {
      state.info.appVersion = action.payload?.app?.version;
    },
    setStartupInfoData(state, action) {
      const startupTime = moment(action.payload * 1000)?.format();
      const startupTimeFormated = formatDateWithTimestamp(startupTime);
      state.info.startup = startupTimeFormated;
    },
    setHealthData(state, action) {
      const { status, components } = action.payload || {},
        { custom, db, diskSpace } = components || {};
      state.services = {};
      state.health = {
        db: {
          name: db?.details?.database,
          status: db?.status,
        },
        diskSpace: {
          total: Math.round(diskSpace?.details?.total / 1e9),
          free: Math.round(diskSpace?.details?.free / 1e9),
        },
      };
      state.info.serverStatus = status;
      state.healthTimestamp = custom.healthTimestamp;
      state.error = undefined;
      state.loading = false;
    },
    fetchAuditLoginEvents(state, action) {
      state.auditLoginEvents = action.payload;
    },
    fetchHttpTraces(state, action) {
      state.httpTraces = action.payload?.map((event) => ({
        timestamp: event.timestamp,
        principal: event.principal?.name,
        method: event?.request?.method,
        uri: event?.request?.uri,
        referer: event?.request?.headers?.referer?.[0],
        status: event?.response?.status,
        timeTaken: event?.timeTaken,
      }));
    },
    setServerStatus(state, action) {
      state.info.serverStatus = action.payload;
      state.healthTimestamp = JSON.parse(JSON.stringify(new Date()));
      state.error = undefined;
      state.loading = false;
    },
  },
});

export const adminPanelActions = adminPanelSlice.actions;

export default adminPanelSlice.reducer;
